import React from "react";

const HeroSection = ({ iframeSrc }) => {

  const handleLogin = () => {
  window.location.href = `/auth/login`;
};

  if (iframeSrc) {
    return (
      <div className="w-full h-[85vh]">
        <iframe
          src={iframeSrc}
          title="Hire360 Page"
          className="w-full h-full border-none rounded-xl shadow-md"
        />
        <p className="text-center text-gray-500 text-sm mt-4">
          Powered by <span className="font-semibold text-[#092162]">4A Consulting LLC</span>
        </p>
      </div>
    );
  }

  return (
    <section className="flex flex-col lg:flex-row items-center justify-between w-full max-w-7xl mx-auto px-6 py-12 gap-12">
      <div className="flex-1 max-w-xl">
        <h1 className="text-5xl lg:text-6xl font-extrabold text-gray-800 mb-6">
          Automate Your Recruitment with{" "}
          <span className="text-[#092162]">Hire360</span>
        </h1>
        <p className="text-gray-600 text-lg mb-8">
          From posting jobs to onboarding candidates, Hire360 streamlines your entire
          recruitment process.
        </p>
      </div>

      <div className="flex-1 max-w-lg bg-white rounded-2xl shadow-md p-8 text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Welcome Back!</h2>
        <p className="text-sm text-gray-500 mb-6">
          Sign in to continue managing your recruitment.
        </p>

        <button
          onClick={handleLogin}
          className="w-full bg-[#092162] hover:bg-[#0b2b8b] text-white py-3 rounded-lg font-semibold"
        >
          Sign in with Microsoft
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
